import { isNonNull } from './isNonNull';

export function formatNumberToNDigits(num: number | string, n: number) {
  return num?.toString().padStart(n, '0');
}
export function formatNumberToNDecimal(num: number, n: number) {
  return parseFloat(num?.toFixed(n));
}

export const valueToNumber = (value: string | number | null | undefined): number | undefined => {
  if (!isNonNull(value)) {
    return undefined;
  }

  const n = Number(value);
  return Number.isNaN(n) ? undefined : n;
};
